import { render, staticRenderFns } from "./RemoveListModal.vue?vue&type=template&id=5cd394c6&"
import script from "./RemoveListModal.vue?vue&type=script&lang=js&"
export * from "./RemoveListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports